import "../styles/main.css";
import "bootstrap";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faCalendarXmark } from "@fortawesome/free-regular-svg-icons";
import { faBoxArchive, faFlag, faBoltLightning, faTriangleExclamation, faCloudArrowUp, faBars } from "@fortawesome/free-solid-svg-icons";

library.add(faBars, faCalendarXmark, faCloudArrowUp, faBoxArchive, faFlag, faBoltLightning, faTriangleExclamation, faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube);
dom.watch();

document.querySelectorAll('.admonition').forEach(elem => {
    let icon = '';
    if (elem.classList.contains('note')) {
        icon = 'fa-flag';
    }
    else if (elem.classList.contains('caution')) {
        icon = 'fa-bolt-lightning';
    }
    else if (elem.classList.contains('danger')) {
        icon = 'fa-triangle-exclamation';
    }
    const titleElem = elem.querySelector('.admonition-title');
    titleElem.insertAdjacentHTML('afterbegin', `<i class="fa-solid ${icon}"></i>`);
});

const toc = document.getElementById('toc');
const subheadings = document.querySelectorAll('.subheading');
if (subheadings) {
    toc.classList.add('col-2');
    const innerElem = document.createElement('div');
    innerElem.classList.add('toc-inner', 'sticky-top');
    innerElem.insertAdjacentHTML('afterbegin', `<p class="toc-title">On this page</p>`);
    subheadings.forEach(elem => {
        innerElem.insertAdjacentHTML('beforeend', `<a class="toc-link" href="#${elem.id}">${elem.textContent}</a>`);
    });
    toc.appendChild(innerElem);
}


document.addEventListener('DOMContentLoaded', (e) => {
    document.querySelectorAll('.advisory-content > table').forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('table-responsive');
        const parent = table.parentNode;
        parent.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
});